module.exports = __webpack_public_path__ + "static/media/statement-clipboard.20543490.svg";